(function (global) {
  'use strict';
  var STORES = ['multi1', 'multi2', 'eu_hlp', 'onebrandska'];
  var SECTION = 'hlx-recommendation-pool';
  function normalized(value) { return String(value || '').normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]/gu, ''); }
  function contextValid(config) {
    return config && config.allowed === true && STORES.includes(config.store) &&
      /^[a-z]{2}$/i.test(config.country) && config.product && Number(config.product.id) > 0 &&
      /^[a-z0-9-]+$/.test(config.product.handle) &&
      (config.store === 'onebrandska' || config.product.handle.endsWith('-' + config.country.toLowerCase()));
  }
  function eligible(product, config) {
    return contextValid(config) && product && Number(product.id) > 0 &&
      /^[a-z0-9-]+$/.test(product.handle) && product.available === true &&
      Number.isFinite(product.price) && product.price > 0 &&
      String(product.id) !== String(config.product.id) && product.handle !== config.product.handle &&
      !normalized(product.vendor).includes('healthlabspharm') &&
      (config.store === 'onebrandska' || product.handle.endsWith('-' + config.country.toLowerCase()));
  }
  function topics(product) {
    return (Array.isArray(product.tags) ? product.tags : []).map(normalized)
      .filter(function (tag) { return tag.length > 2 && !['all', 'sale', 'new', 'bestseller', 'homepage', 'frontpage', 'direct', 'landingpage', 'active', 'online', 'normal', 'vats', 'vat'].includes(tag); });
  }
  function topicQuery(product) {
    var useful = new Set(topics(product));
    var tags = (Array.isArray(product.tags) ? product.tags : []).filter(function (tag) {
      return useful.has(normalized(tag)) && String(tag).length <= 60;
    }).slice(0, 3);
    return tags.length ? '(' + tags.map(function (tag) { return 'tag:' + JSON.stringify(String(tag)); }).join(' OR ') + ')' : '';
  }
  function score(item, current) {
    var tags = new Set(topics(current));
    var shared = topics(item.product).filter(function (tag) { return tags.has(tag); }).length;
    var sameType = normalized(current.type) && normalized(current.type) === normalized(item.product.type);
    var distance = Math.abs(Math.log(item.product.price / Math.max(1, current.price)));
    return (item.native ? 40 : 0) + Math.min(shared, 5) * 15 + (sameType ? 25 : 0) - Math.min(distance, 5);
  }
  function selectRows(candidates, config) {
    var ids = new Set(), handles = new Set();
    var pool = candidates.filter(function (item) {
      var p = item.product;
      if (!eligible(p, config) || ids.has(String(p.id)) || handles.has(p.handle)) return false;
      ids.add(String(p.id)); handles.add(p.handle); return true;
    });
    pool.sort(function (a, b) { return score(b, config.product) - score(a, config.product); });
    // Keep a second row when fewer than eight alternatives exist, without repeating a card.
    var firstCount = pool.length >= 8 ? 4 : Math.ceil(Math.min(pool.length, 8) / 2);
    return {related: pool.slice(0, firstCount), discover: pool.slice(firstCount, firstCount + 4)};
  }
  function urls(config, origin) {
    if (!contextValid(config)) throw new Error('Invalid recommendation market');
    var base = new URL(origin), root = new URL(config.root || '/', base);
    if (root.origin !== base.origin || root.search || root.hash) throw new Error('Invalid locale root');
    var prefix = root.pathname.replace(/\/$/, '');
    function local(path) {
      var url = new URL(path, base);
      if (url.origin !== base.origin || (prefix && !url.pathname.startsWith(prefix + '/'))) throw new Error('Invalid recommendation route');
      url.searchParams.set('section_id', SECTION); return url;
    }
    var related = local(config.recommendationsUrl || prefix + '/recommendations/products');
    related.searchParams.set('product_id', config.product.id);
    related.searchParams.set('limit', '10'); related.searchParams.set('intent', 'related');
    var fallback = local(config.store === 'onebrandska' ? prefix + '/collections/all' : config.searchUrl || prefix + '/search');
    var countryQuery = config.store === 'onebrandska' ? '' : 'tag:' + config.country.toUpperCase();
    if (countryQuery) { fallback.searchParams.set('type', 'product'); fallback.searchParams.set('q', countryQuery); }
    var topic = topicQuery(config.product), pool = new URL(fallback);
    if (topic) {
      pool = local(config.searchUrl || prefix + '/search'); pool.searchParams.set('type', 'product');
      pool.searchParams.set('q', countryQuery ? countryQuery + ' AND ' + topic : topic);
    }
    return {related: related, pool: pool, fallback: fallback, root: prefix};
  }
  function nextPage(href, first) {
    if (!href) return null;
    var next = new URL(href, first);
    if (next.origin !== first.origin || next.pathname !== first.pathname || !/^\d+$/.test(next.searchParams.get('page') || '')) return null;
    // Reapply the original country query even if Shopify omits it in a pagination URL.
    ['q', 'type', 'section_id'].forEach(function (key) {
      if (first.searchParams.has(key)) next.searchParams.set(key, first.searchParams.get(key));
      else next.searchParams.delete(key);
    });
    return next;
  }
  var api = {normalized: normalized, contextValid: contextValid, eligible: eligible, selectRows: selectRows, urls: urls, nextPage: nextPage, topicQuery: topicQuery};
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }
  if (!global.document) return;
  function parsePool(html, config, location, native) {
    var document = new DOMParser().parseFromString(html, 'text/html');
    var pool = document.querySelector('[data-hlx-recommendation-pool]');
    if (!pool || pool.dataset.locale !== config.locale || pool.dataset.currency !== config.currency) return {items: [], next: null};
    var items = [];
    pool.querySelectorAll('template[data-hlx-recommendation-item]').forEach(function (template) {
      try {
        var product = JSON.parse(template.content.querySelector('script[type="application/json"]').textContent);
        if (!eligible(product, config)) return;
        var card = template.content.querySelector('article[data-product]');
        if (!card || card.dataset.product !== product.handle) return;
        var anchors = Array.from(card.querySelectorAll('a[href]'));
        if (!anchors.length || anchors.some(function (anchor) {
          var url = new URL(anchor.getAttribute('href'), location.pool);
          if (url.origin !== location.pool.origin || !url.pathname.endsWith('/products/' + product.handle)) return true;
          // Shopify product.url can be unprefixed inside recommendations. Keep the active language.
          url.pathname = location.root + '/products/' + product.handle;
          anchor.setAttribute('href', url.pathname + url.search + url.hash); return false;
        })) return;
        items.push({product: product, card: card, native: native});
      } catch (_) { /* Ignore incomplete candidates, never replace them with an unfiltered card. */ }
    });
    return {items: items, next: pool.querySelector('[data-hlx-recommendation-next]')?.getAttribute('href') || null};
  }
  async function request(url, config, location, native) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 12000);
    try {
      var response = await fetch(url.toString(), {credentials: 'same-origin', signal: controller.signal, headers: {'X-Requested-With': 'XMLHttpRequest'}});
      if (!response.ok) return {items: [], next: null};
      return parsePool(await response.text(), config, location, native);
    } catch (_) { return {items: [], next: null}; }
    finally { clearTimeout(timer); }
  }
  async function load(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    try {
      var config = JSON.parse(root.querySelector('[data-hlx-recommendation-config]').textContent);
      var location = urls(config, global.location.origin);
      var responses = await Promise.all([request(location.related, config, location, true), request(location.pool, config, location, false)]);
      var candidates = responses[0].items.concat(responses[1].items);
      var page = responses[1], visited = new Set([location.pool.toString()]);
      var rows = selectRows(candidates, config);
      var first = location.pool, fallbackUsed = first.toString() === location.fallback.toString();
      for (var count = 1; count < 6 && rows.related.length + rows.discover.length < 8; count++) {
        var next = nextPage(page.next, first);
        if ((!next || visited.has(next.toString()) || count === 3) && !fallbackUsed) {
          first = location.fallback; next = first; fallbackUsed = true;
        }
        if (!next || visited.has(next.toString())) break;
        visited.add(next.toString()); page = await request(next, config, location, false);
        candidates = candidates.concat(page.items); rows = selectRows(candidates, config);
      }
      ['related', 'discover'].forEach(function (key) {
        var section = root.querySelector('[data-hlx-recommendation-row="' + key + '"]');
        var grid = section.querySelector('[data-hlx-recommendation-grid]');
        rows[key].forEach(function (item) { grid.appendChild(item.card.cloneNode(true)); });
        section.hidden = !rows[key].length;
      });
      root.dataset.loaded = 'true';
    } catch (_) { root.dataset.loaded = 'unavailable'; }
  }
  function initialize() {
    document.querySelectorAll('[data-hlx-auto-recommendations]:not([data-observed])').forEach(function (root) {
      root.dataset.observed = 'true';
      if (!('IntersectionObserver' in global)) { load(root); return; }
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { observer.disconnect(); load(root); }
      }, {rootMargin: '800px'});
      observer.observe(root);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})(typeof window !== 'undefined' ? window : globalThis);
